import { Navigate } from "react-router-dom";
import { useAuth, type UserRole } from "@/contexts/AuthContext";
import { getRoleFallbackRoute } from "@/lib/roleRedirect";

export default function RoleGuard({
  children,
  roles,
  fallback,
}: {
  children: React.ReactNode;
  roles: UserRole[];
  fallback?: string;
}) {
  const { user, loading, hasRole } = useAuth();

  if (loading) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center">
        <i className="ri-loader-4-line animate-spin text-2xl text-[var(--color-text-accent)]"></i>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  const canAccessAsEvaluator =
    roles.includes("evaluador") && user.role === "instructor" && user.can_evaluate;
  if (!hasRole(...roles) && !canAccessAsEvaluator) {
    return <Navigate to={fallback || getRoleFallbackRoute(user)} replace />;
  }

  return <>{children}</>;
}
